import loadingComponent from './loading.vue'
let loadingConstructor = null;
let loadingDom = null;
const loading = (show=true) => {
    if(!loadingDom){
        loadingDom = new loadingConstructor({
            el: document.createElement('div'),
            data() {
                return {
                    show: false
                }
            }
        });
        document.body.appendChild(loadingDom.$el);
    }
    loadingDom.show = show;
};
export default {
    install(vue) {
        // 返回一个 扩展实例构造器
        loadingConstructor = vue.extend(loadingComponent);
        // 注册为全局组件
        vue.prototype.$loading = loading;
    }
}
